<template>
  <div>
    <Suspense>
      <template #default>
        <profile-post-list
          content-author="reply"
          show-parent-annotation
          hide-username
        />
      </template>
      <template #fallback>
        <a-loader
          container-class-name="anz-mt-m"
          :title="$translate('profile.other.loadingSubscribers')"
        />
      </template>
    </Suspense>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ALoader from '@/components/ALoader.vue'
import ProfilePostList from '@/components/Profile/ProfilePostList.vue'

export default defineComponent({
  name: 'AllPostRepliesList',
  components: { ProfilePostList, ALoader },
})
</script>
